var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 74,
    viewBox: "0 0 87 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74018 40.1161H36.3567C40.0184 40.1161 42.9874 43.0688 42.9874 46.7105V62.9783C42.9874 66.6199 40.0184 69.5726 36.3567 69.5726H15.796L11.5488 73.7966L10.1863 69.5726H6.73909C3.07738 69.5726 0.108398 66.6199 0.108398 62.9783V46.7105C0.108398 43.0688 3.07738 40.1161 6.73909 40.1161H6.74018Z",
    fill: "#EC2872",
    stroke: "#211E20",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4379 30.114H46.7323C50.7256 30.114 53.9627 33.3334 53.9627 37.3048V55.0441C53.9627 59.0155 50.7256 62.2349 46.7323 62.2349H24.3134L19.6821 66.8408L18.197 62.2349H14.4379C10.4446 62.2349 7.20752 59.0155 7.20752 55.0441V37.3048C7.20752 33.3334 10.4446 30.114 14.4379 30.114Z",
    fill: "#F15456",
    stroke: "#211E20",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1354 20.113H57.1087C61.4325 20.113 64.9388 23.5991 64.9388 27.9003V47.111C64.9388 51.4111 61.4336 54.8982 57.1087 54.8982H32.8294L27.814 59.8862L26.2053 54.8982H22.1343C17.8105 54.8982 14.3042 51.4122 14.3042 47.111V27.9003C14.3042 23.6002 17.8094 20.113 22.1343 20.113H22.1354Z",
    fill: "#F68139",
    stroke: "#211E20",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8331 10.111H67.4843C72.1397 10.111 75.9142 13.8647 75.9142 18.4946V39.1768C75.9142 43.8067 72.1397 47.5605 67.4843 47.5605H41.3457L35.9462 52.9304L34.2149 47.5605H29.8331C25.1777 47.5605 21.4033 43.8067 21.4033 39.1768V18.4946C21.4033 13.8647 25.1777 10.111 29.8331 10.111Z",
    fill: "#FAAD1D",
    stroke: "#211E20",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.531 0.108887H77.8612C82.8481 0.108887 86.8907 4.1293 86.8907 9.08897V31.2415C86.8907 36.2012 82.8481 40.2216 77.8612 40.2216H49.8632L44.0796 45.9736L42.2247 40.2216H37.531C32.544 40.2216 28.5015 36.2012 28.5015 31.2415V9.08897C28.5015 4.1293 32.544 0.108887 37.531 0.108887Z",
    fill: "#FFD900",
    stroke: "#211E20",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbox);
export default __webpack_public_path__ + "static/media/chatbox.c2e4cd427984a27a2fbcfbef222dd080.svg";
export { ForwardRef as ReactComponent };